module.exports = __webpack_public_path__ + "img/20190525105949562.efbf2eb4.png";